// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h8RiA","icon":"styles_icon__YQ0Rw","gradientStart":"styles_gradientStart__ELW1Y","gradientEnd":"styles_gradientEnd__Dg_ad"};